import { markRaw } from 'vue'
import { Router } from 'vue-router'

export function RouterPlugin(router: Router) {
  return () => ({ $router: markRaw(router) })
}
